import React from 'react';

export default function FormCheckList({label, values, setValues, options, error = '', emptyText = ''}) {
	const safeOptions = Array.isArray(options) ? options : [];
	const safeValues = Array.isArray(values) ? values : [];

	const toggleValue = (e, id) => {
		e.preventDefault();

		setValues((oldValues) => {
			const safeOldValues = Array.isArray(oldValues) ? oldValues : [];

			if (safeOldValues.includes(id)) {
				return safeOldValues.filter((item) => item !== id);
			}

			return [...safeOldValues, id];
		});
	};

	return (
		<div className={`input-div${error !== '' ? ' has-error' : ''}`}>
			{label !== '' || error !== '' ? (
				<div className="input-meta">
					<div className="input-meta-left">{label !== '' ? <div className="input-label">{label}</div> : ''}</div>
					{error !== '' ? <div className="input-error">{error}</div> : ''}
				</div>
			) : (
				''
			)}
			<div className="input-checklist">
				{safeOptions.length === 0 && emptyText !== '' ? <div className="input-checklist__empty">{emptyText}</div> : ''}
				{safeOptions.map((item) => {
					const id = parseInt(item.ID, 10);
					const isChecked = safeValues.includes(id);

					return (
						<div className="input-checklist__item cr_p" key={id} onClick={(e) => toggleValue(e, id)}>
							<button type="button" className={`button check ${isChecked ? 'green' : ''}`} aria-pressed={isChecked}>
								&nbsp;
							</button>
							{item.COLOR ? <span className="input-checklist__dot" style={{backgroundColor: item.COLOR}} /> : ''}
							<span className="input-checklist__name">{item.NAME}</span>
						</div>
					);
				})}
			</div>
		</div>
	);
}
